import {
  Component,
  OnInit,
  ViewChild,
  Output,
  ElementRef,
  EventEmitter
} from '@angular/core';
import { Select, SelectChangeEvent } from 'primeng/select';
import { Table } from 'primeng/table';
import {
  PrivateWorkshopHistory,
  PartnerListUploadItem,
  CustomerListImportItem
} from '../../../models/private-workshop-response.model';
import { AppConstants } from '../../common/app-constants';
import { OsmosisService } from '../../services/osmosis.service';
import { AccessListErrorLogComponent } from '../access-list-error-log/access-list-error-log.component';
import { DocumentUploadComponent } from '../document-upload/document-upload.component';
import { CommonSharedModule } from '../../common/shared.module';

@Component({
  selector: 'app-upload-history',
  templateUrl: './upload-history.component.html',
  styleUrls: ['./upload-history.component.scss'],
  standalone: true,
  imports: [
    AccessListErrorLogComponent,
    DocumentUploadComponent,
    CommonSharedModule
  ]
})
export class UploadHistoryComponent implements OnInit {
  pageLinksPerPage!: number;
  dataViewRecsPerPage!: number;
  loadingIcon = 'fa-circle-o-notch';
  scrollableCols = new Array<any>();
  globalFilterCols = new Array<any>();
  fileTypes = new Array<any>();
  privateWorkshopUploadHistory!: PrivateWorkshopHistory[];
  totalRecords!: number;
  tblPageNumber!: number;
  @ViewChild('dt', { static: false }) dt!: Table;
  @ViewChild('dropdown', { static: false }) dropdown!: Select;
  @Output() refreshList = new EventEmitter<any>();
  showLogs = false;
  @ViewChild('viewLogModal', { static: false })
  viewLogModal!: AccessListErrorLogComponent;
  @ViewChild('AccessListFileUpload', { static: false })
  accessListFileUpload!: ElementRef;
  @ViewChild('uploadDocumentDialogue', { static: false })
  uploadDocumentDialogue!: DocumentUploadComponent;
  workshopTypeId!: number;
  loading = false;
  engagementType = '';
  isHybridWithCustomerList!: boolean;
  isHybridWithPartnerList!: boolean;

  constructor(private osmService: OsmosisService) {}

  ngOnInit(): void {
    this.pageLinksPerPage = AppConstants.dataListPagerLinks;
    this.dataViewRecsPerPage =
      AppConstants.privateworkshopUploadHistoryRecsPerPage;

    this.scrollableCols = [
      { field: 'active', header: 'Active' },
      { field: 'documentDisplayName', header: 'File Name' },
      { field: 'fileType', header: 'File Type' },
      { field: 'createdOn', header: 'Upload Date' },
      { field: 'createdByUserAlias', header: 'Uploaded by' },
      { field: 'errors', header: 'Errors' }
    ];
    this.fileTypes = [{ type: 'Partner' }, { type: 'Customer' }];
    this.privateWorkshopUploadHistory = [];

    this.globalFilterCols = ['createdOn', 'fileType'];
    this.showLogs = false;
  }

  applyFilter(event): void {
    this.totalRecords = event.filteredValue.length;
    this.pageChange({ first: 0 });
  }

  get currentPageInfo(): string {
    if (
      this.privateWorkshopUploadHistory != null &&
      this.totalRecords == undefined
    ) {
      this.totalRecords = this.privateWorkshopUploadHistory.length;
    }
    if (this.totalRecords === 0) {
      return 'No Record Found';
    } else if (
      this.tblPageNumber + this.dataViewRecsPerPage >
      this.totalRecords
    ) {
      return (
        'Showing ' +
        (this.tblPageNumber + 1) +
        ' - ' +
        this.totalRecords +
        ' of ' +
        this.totalRecords +
        ' Records'
      );
    } else if (
      this.tblPageNumber + this.dataViewRecsPerPage <=
      this.totalRecords
    ) {
      return (
        'Showing ' +
        (this.tblPageNumber + 1) +
        ' - ' +
        (this.tblPageNumber + this.dataViewRecsPerPage) +
        ' of ' +
        this.totalRecords +
        ' Records'
      );
    } else if (
      this.totalRecords > 0 &&
      this.totalRecords > this.dataViewRecsPerPage
    ) {
      return (
        'Showing 1 - ' +
        1 * this.dataViewRecsPerPage +
        ' of ' +
        this.totalRecords +
        ' Records'
      );
    } else if (
      this.totalRecords > 0 &&
      this.totalRecords <= this.dataViewRecsPerPage
    ) {
      return (
        'Showing 1 - ' +
        this.totalRecords +
        ' of ' +
        this.totalRecords +
        ' Records'
      );
    }
    return '';
  }

  pageChange(e): void {
    this.tblPageNumber = e.first;
  }

  loadWorkshopUploadHistory(workshopTypeId): void {
    this.workshopTypeId = workshopTypeId;
    this.loading = true;
    this.osmService
      .getPrivateWorkshopHistory(workshopTypeId)
      .subscribe(response => {
        this.loading = false;
        this.privateWorkshopUploadHistory = Object.assign(response);
      });
  }

  reset(): void {
    if (this.dt) {
      this.dt.reset();
    }
    this.refreshList.emit(true);
  }

  filterTable(event: SelectChangeEvent): void {
    if (this.dt) {
      if ((event as any).value !== null) {
        this.dt.filter((event as any).value.type, 'fileType', 'contains');
      } else {
        this.dt.reset();
      }
    }
  }

  viewLog(
    uploadResult: PartnerListUploadItem | CustomerListImportItem,
    fileType: string
  ): void {
    this.viewLogModal.loadError(uploadResult, fileType, true);
    this.showLogs = true;
  }

  showUploadDialog(): void {
    this.uploadDocumentDialogue.selectedWorkshopType = this.workshopTypeId;
    this.uploadDocumentDialogue.selectedEngagementType = this.engagementType;
    this.uploadDocumentDialogue.isHybridWithCustomerList =
      this.isHybridWithCustomerList;
    this.uploadDocumentDialogue.isHybridWithPartnerList =
      this.isHybridWithPartnerList;
    this.uploadDocumentDialogue.showDialog();
  }

  get isWorkshopTypeSelected(): boolean {
    return this.workshopTypeId ? true : false;
  }
}
